module.exports = __webpack_public_path__ + "img/10corazon.60ab387c.png";